import { createFileRoute } from "@tanstack/react-router";

import { AdminBillingPlansScreen } from "@/features/admin/screens/AdminBillingPlans";

export const Route = createFileRoute(
  "/_authenticated/(admin)/admin/billing-plans",
)({
  component: AdminBillingPlansScreen,
});
